import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlAidFieldsFragment = { agendaItemId: string, createdAt: string, decisionPrimaryLang?: string | null, decisionSecondaryLang?: string | null, id: string, order: number, updatedAt: string };

export const AidFieldsFragmentDoc = gql`
    fragment AidFields on AgendaItemDecision {
  agendaItemId
  createdAt
  decisionPrimaryLang
  decisionSecondaryLang
  id
  order
  updatedAt
}
    `;